// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLayoutOutlinedSvg from "@fishx/icons-svg/es/asn/PLayoutOutlined";
import FishxIcon from '../components/FishxIcon';

var PLayoutOutlined = function PLayoutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLayoutOutlinedSvg
  }));
};

PLayoutOutlined.displayName = 'PLayoutOutlined';
export default React.forwardRef(PLayoutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLayoutOutlined.js
// module id = 3480
// module chunks = 0